"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DrunkenClarityEffectHandler = exports.DrunkenClarityEffectArgs = void 0;
const _1 = require(".");
const Duration_1 = require("../../Duration");
const enums_1 = require("../../enums");
const Registries_1 = require("../../state/Registries");
const EffectType_1 = require("../EffectType");
class DrunkenClarityEffectArgs {
    constructor(
    // this really should be named scoreIncrease, but cannot be renamed without breaking existing adventures.
    focusIncrease, attributeToIncrease = enums_1.AttributeType.Focus) {
        this.focusIncrease = focusIncrease;
        this.attributeToIncrease = attributeToIncrease;
        this.__type = EffectType_1.EffectType.DrunkenClarity;
        this.__typeName = "DrunkenClarity";
        this.name = "Drunken Clarity";
        this.harmful = false;
    }
}
exports.DrunkenClarityEffectArgs = DrunkenClarityEffectArgs;
let DrunkenClarityEffectHandler = class DrunkenClarityEffectHandler {
    apply(sequence, container, state) {
        state.meta.focusIncreaseEffectId = container.applyBuff({
            sequence,
            creatorId: state.creatorId,
            targetId: state.targetId,
            effect: new _1.MaxAttributeIncreaseEffectArgs(state.args.attributeToIncrease, state.args.focusIncrease),
            duration: Duration_1.Duration.Permanent,
            supernatural: true,
        });
    }
    remove(sequence, container, state) {
        container.cancelEffect(sequence, state.meta.focusIncreaseEffectId);
    }
};
DrunkenClarityEffectHandler = __decorate([
    Registries_1.Effects.register(EffectType_1.EffectType.DrunkenClarity)
], DrunkenClarityEffectHandler);
exports.DrunkenClarityEffectHandler = DrunkenClarityEffectHandler;
